import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useGlobalContext } from '../context/GlobalContext';
import LanguageDropdown from './LanguageDropdown';
import { useTranslation } from 'react-i18next';

function Header() {
  const navigate = useNavigate();
  const { siteInfo, token, changeLanguage } = useGlobalContext();
  const { t } = useTranslation();

  const handleLanguageSelect = (languageCode) => {
    changeLanguage(languageCode);
  };

  const handleLogout = () => {
    navigate('/logout');
  };

  if (!siteInfo) {
    return null;
  }

  return (
    <header id="header">
      <div>
        <span>
          <a href={siteInfo.site} target="_blank" rel="noopener noreferrer">
            <img src={siteInfo.logo} className="logo" alt={siteInfo.libelle} />
          </a>
        </span>
        <nav>
          <ul>
            <li>
              {!token ? (
                <Link to="/home" className="mainColor">
                  {t('Voir mes bons d\'achat')}
                </Link>
              ) : (
                <Link to={`/cards/${token}`} className="mainColor">
                  {t('Voir mes bons d\'achat')}
                </Link>
              )}
            </li>
            <li>
              <Link to="/help" className="mainColor">
                {t('Aide')}
              </Link>
            </li>
          </ul>
        </nav>
      </div>
      
      <div>
        <LanguageDropdown
          languages={siteInfo.languages}
          onSelect={handleLanguageSelect}
          showFlag={siteInfo.display_language_flag}
        />
        {token && (
          <a class="mainColor" href="/logout">Se déconnecter</a>
        )}
      </div>
    </header>
  );
}

export default Header;